import { useTranslation } from "next-i18next";

import SearchIcon from "@/components/icons/SearchIcon";
import CloseIcon from "@/components/icons/CloseIcon";
import { checkSearchLang } from "@/utils/global";

const Search = ({
  inputValue,
  setInputValue,
  ourSearchInput,
  ourSearchButton,
  setProductIdx,
}) => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation("common");
  return (
    <div className="flex items-center flex-1 mx-1 sm:mx-5 md:gap-4">
      <div className="flex items-center flex-1 gap-1 p-1 border md:p-2 rounded-s-md md:rounded-lg">
        <input
          ref={ourSearchInput}
          placeholder={t("SearchFavProducts")}
          className="max-[640px]:w-12 max-sm:placeholder:text-xs flex-1 md:h-auto border-none outline-none px-2 placeholder:text-sm sm:placeholder:text-base"
          value={inputValue}
          onChange={(event) => {
            const searchLang = checkSearchLang(
              event.currentTarget.value,
              locale
            );
            setProductIdx(
              searchLang === "ar"
                ? process.env.NEXT_PUBLIC_ALGOLIA_IDX_AR
                : process.env.NEXT_PUBLIC_ALGOLIA_IDX_EN
            );
            setInputValue && setInputValue(event.currentTarget.value);
          }}
          autoFocus
          autoComplete="on"
          autoCorrect="on"
          autoCapitalize="on"
        />
        {inputValue ? (
          <CloseIcon
            className="cursor-pointer text-zinc-400 size-3"
            onClick={() => setInputValue("")}
          />
        ) : null}
      </div>
      <button
        ref={ourSearchButton}
        className="flex items-center justify-center w-12 p-2 py-[9px] text-white sm:w-16 rounded-e-md md:rounded-lg md:w-24 bg-primary-to-b"
      >
        <span className="hidden md:inline">{t("Search")}</span>
        <SearchIcon className="text-white md:hidden size-4" />
      </button>
    </div>
  );
};

export default Search;
